
import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractRepositoryV2} from '../../../../../core/service/v2/abstractRepositoryV2';
import {DocumentModel} from '../../../api/model/document.model';

@Injectable({
    providedIn: 'root'
})
export class DocumentRepository extends AbstractRepositoryV2<DocumentModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('Document', serviceElementsFactory, injector);
    }
}
